import { Chart } from "chart.js";
// import "chartjs-plugin-deferred";

const Charts = (target) => {

  const el = {
    chart: target,
  };

  const method = {
    init: () => {
      const initialData = (window as any).charts;
      const chartData = initialData.filter((obj: { id: any }) => obj.id === el.chart.getAttribute("data-chart"));
      const chartArray = chartData[0].data;
      const labelArray = [];
      const valuesArray = [];

      chartArray.forEach((labels) => {
        labelArray.push(labels.label);
      });

      chartArray.forEach((values) => {
        valuesArray.push(values.value);
      });

      function BuildChart(labels, values) {

        const canvas = document.getElementById("doughnutChart") as HTMLCanvasElement;
        const ctx = canvas.getContext("2d");

        const donutChart = new Chart(ctx, {
          type: "doughnut",
          data: {
            labels,
            datasets: [{
              data: values,
              backgroundColor: [
                "#db7802",
                "#2a5e65",
                "#3645b0",
                "#444",
                "#e56353",
                "#f2db09",
              ],
              borderWidth: 0,
            }],
          },
          options: {
            legend: {
              display: false,
            },
            animation: {
              duration: 2000,
            },
            // plugins: {
            //   deferred: {
            //     enabled: true,
            //     yOffset: 50,
            //     delay: 800,
            //   },
            // },
          },
        });

        return donutChart;
      }

      BuildChart(labelArray, valuesArray);
    },
  };

  method.init();
};

export default Charts;
